import { Component, HostListener, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { displayPayLink, verifyLink, removeIFrame, initializaVerifyLink } from '../../assets/dollarpay.js'

import { Router, ActivatedRoute } from '@angular/router';


import { HttpService } from '../services/httpService';

@Component({
  selector: 'app-verify-component',
  templateUrl: './verify.component.html'
})
export class VerifyComponent {
  public currentCount = 0;

  public incrementCounter() {
    this.currentCount++;
  }

  source;
  loading: boolean = false;

  paymentAlreadyDone: boolean = false;

  constructor(public router: Router, private activeRoute: ActivatedRoute, private httpService: HttpService
  ) {

    this.source = decodeURI(this.activeRoute.snapshot.params['id']);

    this.fetchDetails();

    initializaVerifyLink(this.source);

  }
  vendor;


  fetchDetails() {

    this.loading = true;
    const request = {
      Id: this.source
    }



    this.httpService.post<any>('Store/fetch-dwolla-customer-id-details', request, false).subscribe(
      resp => {
        this.vendor = JSON.parse(resp.message);

        if (this.vendor.bankAccountVerified == 1) {

          this.paymentAlreadyDone = true;

        }

        this.loading = false;

      },
      error => {
        this.loading = false;

        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });


  }

  show() {



    verifyLink(this.source);




  }


  success: boolean = false;
  start: boolean = true;
  transactionId;

  @HostListener('window:message', ['$event'])
  onMessage(event) {

    console.log(event)
    const data = JSON.parse(event.data);
    //console.log(data.message)

    if (data.message == 'success') {

      //this.transactionId = data.transactionId;
      removeIFrame();

      this.start = false;
      this.success = true;


    }



    if (data.message == 'terminated') {
      console.log("termination")
      removeIFrame();


    }

  };


}
